module.exports = __webpack_public_path__ + "media/images/countrysquared/so-34e05505fa8ec222cee0f68c3dd3cae2.svg";